import Calendar from './calendar.png';
import PaperclipIcon from './paperclip.png';
import UserIcon from './user.png';
import ArrowLeft from './arrow-left.png';
import LockIcon from './lock.png';
import PasswordInactive from './password-inactive.png';
import PasswordActive from './password-active.png';
import LogoutIcon from './logout.png';
import ProfileIcon from './profile.png';
import DownloadIcon from './download.png';
import EditIcon from './edit.png';
import AddIcon from './add.png';
import SearchIcon from './search.png';
import TrashIcon from './trash.png';
import ArrowUp from './arrow-up.png';
import ArrowBottom from './arrow-bottom.png';
import ViewIcon from './view.png';
import MailIcon from './mail.png';
import TimeIcon from './time.png';
import ArrowBottomBlack from './arrow-bottom-black.png';
import ArrowUpBlack from './arrow-up-black.png';
import CalendarWhite from './calendar-white.png';
import DeleteIcon from './delete.png';
import CalendarRed from './calendar-red.png';
import CloseIcon from './close.png';
import CheckGreenIcon from './check-green.png';
import MenuIcon from './menu.png';
import LogoutGray from './logout-gray.png';
import ArrowLeft2 from './arrow-left2.png';
import LocationIcon from './location.png';
import PhoneIcon from './phone.png';
import FacebookIcon from './facebook.png';
import InstagramIcon from './instagram.png';
import WebIcon from './web.png';
import CleanIcon from './clean.png';
import ArrowRight from './arrow-right.png';
import ClinicIcon from './clinic.png';
import PatientIcon from './patient.png';
import DoctorIcon from './doctor.png';
import UploadIcon from './upload.png';
import ArrowLeftBlack from './arrow-left-black.png';
import ArrowRightBlack from './arrow-right-black.png';
import CheckWhiteIcon from './check-white.png';
import StarIcon from './star.png';
import StarActiveIcon from './star-active.png';
import XLSIcon from './xls.png';
import Download2Icon from './download2.png';
import EyeBlackIcon from './eye-black.png';
import DownloadBlackIcon from './download-black.png';
import AlertIcon from './alert.png';
import SurgerieIcon from './surgerie.png';
import ExamIcon from './exam.png';
import CheckIcon from './check.png';
import ExisIcon from './exis.png';
import PrinterIcon from './printer.png';
import ContactCallIcon from './contact-call.png';
import ContactMessageIcon from './contact-message.png';
import ContactVideoCallIcon from './contact-video-call.png';
import SwitchOffIcon from './switch-off.png';
import SwitchOnIcon from './switch-on.png';
import PDFIcon from './pdf.png';
import FileIcon from './file.png';
import CheckmarkBadgeIcon from './checkmark-badge.png';
import EllipsisVIcon from './ellipsis-v.png';
import CallIcon from './llamada.png';
import ChatIcon from './chat.png';
import VideoCallIcon from './videollamada.png';
// Menu
import Menu0 from './menu/menu0.png';
import Menu1 from './menu/menu1.png';
import Menu2 from './menu/menu2.png';
import Menu3 from './menu/menu3.png';
import Menu4 from './menu/menu4.png';
import Menu5 from './menu/menu5.png';
import Menu6 from './menu/menu6.png';
import Menu7 from './menu/menu7.png';
import Menu8 from './menu/menu8.png';
import Menu9 from './menu/menu9.png';
import Menu10 from './menu/menu10.png';
import Menu11 from './menu/menu11.png';
import Menu12 from './menu/menu12.png';
import Menu13 from './menu/menu13.png';
import Menu14 from './menu/menu14.png';
import Menu15 from './menu/menu15.png';
import Menu16 from './menu/menu16.png';
import Menu17 from './menu/menu17.png';
import Menu18 from './menu/menu18.png';
import pagos from './menu/pagos.png';
import Calification from './menu/calification.png';
import ClasificadosIcon from './clasificados.png';
import BannersIcon from './banners.png';

const Menu = {
	Menu0,
	Menu1,
	Menu2,
	Menu3,
	Menu4,
	Menu5,
	Menu6,
	Menu7,
	Menu8,
	Menu9,
	Menu10,
	Menu11,
	Menu12,
	Menu13,
	Menu14,
	Menu15,
	Menu16,
	Menu17,
	Menu18,
	Calification,
	pagos,
}

export {
	EllipsisVIcon,
	Calendar,
	ArrowLeft,
	PaperclipIcon,
	UserIcon,
	LockIcon,
	PasswordInactive,
	PasswordActive,
	LogoutIcon,
	ProfileIcon,
	DownloadIcon,
	EditIcon,
	AddIcon,
	SearchIcon,
	TrashIcon,
	ArrowUp,
	ArrowBottom,
	ViewIcon,
	MailIcon,
	TimeIcon,
	ArrowBottomBlack,
	ArrowUpBlack,
	CalendarWhite,
	DeleteIcon,
	CalendarRed,
	CloseIcon,
	CheckGreenIcon,
	Menu,
	MenuIcon,
	LogoutGray,
	ArrowLeft2,
	LocationIcon,
	WebIcon,
	InstagramIcon,
	FacebookIcon,
	PhoneIcon,
	CleanIcon,
	ArrowRight,
	ClinicIcon,
	PatientIcon,
	DoctorIcon,
	UploadIcon,
	ArrowLeftBlack,
	ArrowRightBlack,
	CheckWhiteIcon,
	StarActiveIcon,
	StarIcon,
	XLSIcon,
	Download2Icon,
	EyeBlackIcon,
	DownloadBlackIcon,
	AlertIcon,
	ExamIcon,
	SurgerieIcon,
	CheckIcon,
	ExisIcon,
	PrinterIcon,
	ContactCallIcon,
	ContactMessageIcon,
	ContactVideoCallIcon,
	ClasificadosIcon,
	BannersIcon,
	SwitchOffIcon,
	SwitchOnIcon,
	PDFIcon,
	FileIcon,
	CheckmarkBadgeIcon,
	CallIcon,
	ChatIcon,
	VideoCallIcon,
}